<template>
	<div class="box" style="height: 421px">
		<div class="d-flex flex-row h-100">
			<div class="flex d-flex flex-column h-100">
				<div class="no-shrink padding pb-2">
					<span class="float-right text-muted">
						<a @click="loadData" class="no-select btn-subtle" v-tippy title="Refresh">
							<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
						</a>
					</span>
					<h6>User Activity</h6>
				</div>
				<div class="flex scroll-y inset px-3 pb-3 pt-0">
					<table>
						<tr v-for="row in rows" :key="row.user.id" class="b-b">
							<td style="width: 32px;">
								<div
									class="w-32 avatar circle text-white"
									:style="{ 'background-color': avatarColor(row) }"
								>
									{{ initials(row.user) }}
								</div>
							</td>
							<td style="width: 25%">
								<div class="item-title _500">
									{{ row.user.full_name }}
									<span class="text-muted">({{ row.user.scorer_id }})</span>
								</div>
								<div class="text-muted">{{ row.role_name }}</div>
							</td>
							<td>
								<div class="text-muted">
									<i class="far fa-graduation-cap text-center align-icons mr-1" />
									{{ row.district_name }}
								</div>
								<div class="text-muted">
									<span>{{ joinList(row.content_area_names) }}</span>
									<span
										v-if="
											row.content_area_names &&
												row.grade_names &&
												row.content_area_names.length &&
												row.grade_names.length
										"
										>|</span
									>
									<span>{{ joinList(row.grade_names) }}</span>
								</div>
							</td>
							<td>
								<div class="float-right" :class="{ 'text-muted': !row.current_session }">
									<div :class="{ _500: row.current_session }" style="text-align: right;">
										{{ getActivityPage(row) }}
									</div>
									<div style="text-align: right;">{{ sinceString(row.time) }}</div>
								</div>
							</td>
							<td style="width: 32px;" class="b-r">
								<div class="item-action dropdown pr-2">
									<div
										v-b-popover
										:id="`u-${row.user.id}-activity`"
										:class="{ 'text-very-muted': !row.current_session }"
									>
										<i class="fa fa-fw fa-lg" :class="{ [getActivityIcon(row)]: true }"></i>
									</div>
									<b-popover :target="`u-${row.user.id}-activity`" triggers="hover" placement="left">
										<template slot="title">Current Activity</template>
										<div class="w">
											<div class="form-group">
												<div v-if="row.current_session" class="text-muted">Page</div>
												<div class="text">
													{{ getActivityPage(row) }}
													<span v-if="getActivitySubtask(row)" class="text text-muted"
														>({{ getActivitySubtask(row) }})</span
													>
												</div>
												<div
													v-if="
														row.current_session && row.current_session.params.section_name
													"
													class="text"
												>
													<i class="fas fa-briefcase fa-fw text-muted"></i>
													{{ row.current_session.params.section_name }}
												</div>
												<div
													v-if="row.current_session && row.current_session.params.item_name"
													class="text"
												>
													<i class="fas fa-book fa-fw text-muted"></i>
													{{ row.current_session.params.item_name }}
												</div>
											</div>
											<div class="form-group">
												<div v-if="row.current_session" class="text-muted">Last Activity</div>
												<div v-if="!row.current_session" class="text-muted">Last Log-in</div>
												<div class="text">{{ medDate(row.time) }}</div>
											</div>
										</div>
									</b-popover>
								</div>
							</td>
							<td class="side-actions">
								<div class="d-flex flex-row align-items-center justify-content-end h-100">
									<div
										class="switch d-flex flex-column align-items-center"
										v-tippy
										title="Inactive users cannot score"
									>
										<div style="height: 23px; padding-top: 2px;">
											<label class="ui-switch ui-switch-sm theme-accent">
												<input @change="setActive(row)" type="checkbox" v-model="row.active" />
												<i></i>
											</label>
										</div>
										<div class="text-muted">Active</div>
									</div>
									<!-- <a
										v-if="user.role.page_reporting"
										class="text-center icon"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										<div>
											<i class="fa fa-chart-bar fa-lg"></i>
										</div>
										<div>Report</div>
									</a>-->
									<div class="dropdown-menu w-xxl scroll-y" style="max-height: 421px;">
										<a
											v-for="link in getUserItemRows(row.user)"
											:key="link.section_id + link.item_id"
											class="dropdown-item"
											@click="goToSummary(row.user, link)"
										>
											<label class="mb-0">
												<i class="far fa-briefcase"></i>
												{{ link.section_name }}
											</label>
											<i class="far fa-angle-right"></i>
											<label class="mb-0">
												<i class="far fa-book"></i>
												{{ link.item_name }}
											</label>
										</a>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="rows.length < totalRows" style="border-top: 0px solid black;">
							<td colspan="5">
								<div class="text-center p-2">
									<a
										v-if="totalRows - showRows > perPage && !busy"
										@click="loadMore()"
										class="btn btn-sm white"
									>
										Show More
										<span class="text-muted text-xxs">({{ perPage.toLocaleString() }})</span>
									</a>
									<a v-if="!busy" @click="loadAll()" class="btn btn-sm white">
										Show All
										<span class="text-muted text-xxs"
											>({{ (totalRows - showRows).toLocaleString() }})</span
										>
									</a>
									<loading v-if="busy" type="icon" style="font-size: 30px;" class="text-muted" />
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
a:not(.exception) {
	opacity: 0.6;
	transition: opacity 0.25s;
}
a:not(.exception):hover {
	opacity: 1;
}
a.exception {
	opacity: 1;
	transition: opacity 0.25s;
}
.item-action > a {
	margin-top: -0.6rem;
	margin-bottom: -0.6rem;
	padding-top: 0.6rem;
	padding-bottom: 0.6rem;
}
table {
	width: 100%;
}
td {
	padding: 0.75rem 0.5rem;
	vertical-align: middle;
}
.dropdown-item {
	white-space: normal;
	padding: 0.25rem 0.75rem;
}
.dropdown-item i {
	width: 1.2rem;
	margin-left: 0;
	margin-right: 0;
	text-align: center;
	opacity: 0.7;
}
::-webkit-scrollbar {
	width: 7px;
	background-color: #fff;
	border-radius: 4px;
}
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.2);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.side-actions {
	width: 1px;
}
.icon {
	width: 50px;
}
.switch {
	width: 50px;
}
.align-icons {
	width: 23px;
}
</style>

<script>
import ActivityService from "@/services/ActivityService";
import ReportingService from "@/services/ReportingService";
import TenantService from "@/services/TenantService";
import UserService from "@/services/UserService";
import ThemeService from "@/services/ThemeService";
import store from "@/services/Store";
import notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import chartjs from "chart.js";
require("@/directives/chartjs");
import moment from "moment";

export default {
	name: "TrafficDashUserActivity",

	props: ["team", "user"],

	data() {
		return {
			fs: fs,
			icons: {
				Login: "fa-browser", //Yes, Login should map to 'Landing'
				Landing: "fa-browser",
				BulletinBoard: "fa-browser",
				Dashboard: "fa-tachometer-alt",
				SupervisorDashboard: "fa-tachometer-alt",
				ProjectDashboard: "fa-tachometer-alt",
				Profile: "Profile",
				Scoring: "fa-check",
				Backreading: "fa-check",
				Mail: "fa-envelope",
				Viewer: "fa-check",
				Resolution: "fa-check",
				BackreadViewer: "fa-check",
				QueueBackreadViewer: "fa-check",
				FlagQueueViewer: "fa-check",
				QCTrueScoreViewer: "fa-balance-scale",
				TrainingViewer: "fa-balance-scale",
				QCUserSetReport: "fa-balance-scale",
				ReportCompletion: "fa-chart-bar",
				ReportScorers: "fa-chart-bar",
				ReportDaily: "fa-chart-bar",
				ReportUserSummary: "fa-chart-bar",
				ReportItemSummary: "fa-chart-bar",
				ReportUserAgreement: "fa-chart-bar",
				ReportProjectAgreement: "fa-chart-bar",
				Burndown: "fa-chart-bar",
				Auditing: "fa-barcode-alt",
				ScoreAuditing: "fa-barcode-alt",
				ResetHistory: "fa-barcode-alt",
				QCSetup: "fa-balance-scale",
				QCSetResponses: "fa-balance-scale",
				QCReport: "fa-balance-scale",
				QCUserSetReport: "fa-balance-scale",
				UserSetup: "fa-user",
				UserEdit: "fa-user",
				TeamSetup: "fa-users",
				TeamEdit: "fa-users",
				TenantSetup: "fa-building",
				TenantEdit: "fa-building",
				ProjectSetup: "fa-box-open",
				ProjectEdit: "fa-box-open",
				SectionSetup: "fa-briefcase",
				SectionEdit: "fa-briefcase",
				ItemSetup: "fa-book",
				ItemEdit: "fa-book",
				RubricSetup: "fa-tasks",
				RubricEdit: "fa-tasks",

				"Traffic Dashboard": "fa-tachometer-alt"
			},
			subtasks: {
				Resolution: "resolution",
				BackreadViewer: "backreading",
				QueueBackreadViewer: "backreading",
				FlagQueueViewer: "flag_queue",
				TrainingViewer: "training",
				QCUserSetReport: "qc_user_set"
			},
			rows: [],
			totalRows: 0,
			perPage: 10,
			showRows: null,

			roleNames: {},

			client: [],

			busy: false
		};
	},
	created() {
		this.showRows = this.perPage;
		this.loadData();
	},
	watch: {
		"team.id"() {
			this.loadData();
		}
	},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			let tid = this.team && this.team.id;

			let ctx = {
				currentPage: 1,
				perPage: this.showRows
			};
			if (this.team) {
				ctx.teamIDs = [this.team.id];
			}

			this.busy = true;
			Promise.all([ActivityService.getUsersCurrentActivity(ctx), TenantService.getClient()])
				.then(resps => {
					//resps[0] - activities
					this.rows = resps[0].data.activities;
					this.totalRows = resps[0].data.totalRows;

					//give one person an exception for mockup
					let rand = Math.floor(Math.random() * this.rows.length);
					this.rows[rand].exception = { reason: "Validity" };
					console.log("Exception added to", rand, this.rows[rand]);

					//resps[1] - assignments
					this.client = resps[1].data;

					//resps[2] - client
					this.roleNames = {};
					_.each(resps[0].data.roles, role => {
						this.roleNames[role.id] = role.name;
					});
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.busy = false;
				});
		},

		loadMore() {
			this.showRows += this.perPage;
  			this.sleep(2000);
			this.loadData();
		},
sleep(ms) {
  return new Promise(
    resolve => setTimeout(resolve, ms)
  );
},
		loadAll() {
			this.showRows = this.totalRows   
			this.loadData();
		},

		initials(user) {
			let names = user.full_name.split(" ");
			let first_initial = names[0] ? names[0].substring(0, 1).toUpperCase() : "";
			let last_initial = names[1] ? names[1].substring(0, 1).toUpperCase() : "";
			return first_initial + last_initial;
		},

		getActivityIcon(act) {
			let page = act.current_session && act.current_session.page;
			if (!page) {
				return "fa-minus";
			}
			return this.icons[page] || "fa-map-marker-question";
		},

		getActivityPage(act) {
			let page = act.current_session && act.current_session.page;
			if (!page) {
				return "Logged out";
			}
			return page;
		},

		getActivitySubtask(act) {
			let page = act.current_session && act.current_session.page;
			if (!page) {
				return null;
			}
			let subtask = this.subtasks[page];
			if (!subtask) {
				return null;
			}
			return this.$i18n.t(`label.subtask.${subtask}`);
		},

		getUserItemRows(user) {
			//Get all sections the user is assigned to under the teams we're currently looking at
			let sections = {};
			_.each(this.team_assignments, ta => {
				let assigned = _.find(ta.users, r => {
					return r.user.id == user.id;
				});
				if (assigned) {
					_.each(ta.sections, section => {
						sections[section.id] = section;
					});
				}
			});

			//Construct a section/item row for each item in the relevant sections
			let rows = [];
			_.each(sections, section => {
				_.each(section.items, item => {
					rows.push({
						section_id: section.id,
						section_name: section.name,
						item_id: item.id,
						item_name: item.name
					});
				});
			});

			return rows;
		},

		goToSummary(user, link) {
			if (!this.user.role.page_reporting) {
				return;
			}
			user.name = fs.nameWithScorerID(user);
			store.set(this, "userSummary.selectedUser", user);
			store.set(this, "userSummary.selectedSection", {
				id: link.section_id
			});
			store.set(this, "userSummary.selectedItem", { id: link.item_id });
			store.set(this, "userSummary.auto", true);
			this.$router.push("/reporting/user_summary");
		},

		isZeroDate(date) {
			if (date.substring(0, 4) == "0001") {
				return true;
			} else {
				return false;
			}
		},

		medDate(date) {
			return this.isZeroDate(date) ? "Never" : fs.medDate(date);
		},

		sinceString(date) {
			return this.isZeroDate(date) ? "Never" : fs.sinceString(date);
		},

		getColor(user) {
			let colors = [
				"red",
				"pink",
				"purple",
				"deep-purple",
				"indigo",
				"blue",
				"light-blue",
				"cyan",
				"teal",
				"green",
				"orange",
				"brown",
				"blue-grey",
				"grey"
			];

			let i = Math.floor(Math.random() * colors.length);
			return colors[i];
		},

		setActive(row) {
			var action = row.active ? "activate" : "deactivate";
			var failValue = !row.active;
			console.log(row);
			UserService[action](row.user)
				.then(resp => {
					notie.info(`User ${action}d`);
				})
				.catch(err => {
					notie.error(`Failed to ${action} user`, err);
					row.active = failValue;
				});
		},

		avatarColor(row) {
			if (!row.current_session) {
				return "#E0E0E0";
			}

			if (!row.theme) {
				row.theme = "info";
			}
			let themeColor = ThemeService.getThemeColorHex(row.theme);
			return themeColor;
		},

		joinList(list) {
			return list.join(", ");
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/TrafficDashboard/TrafficDashUserActivity.vue